module.exports = __webpack_public_path__ + "static/fipcspottygmain-22a11d0d9e46ebb7d81cd3e9a037fb65.jpeg";